export const initMegaMenu = (header) => {
  const megaMenu = header.querySelector(".mega-menu");
  const sub1Menus = header.querySelectorAll(".sub1-menu");
  const sub2Menus = header.querySelectorAll(".sub2-menu");
  const sub3Menus = header.querySelectorAll(".sub3-menu");

  const allItems = header.querySelectorAll("[data-identifier]");
  const allMenuItems = header.querySelectorAll(".menu-item");
  const menuItems = header.querySelectorAll(".main-menu .menu-item");
  const sub1MenuItems = header.querySelectorAll(".sub1-menu .menu-item");
  const sub2MenuItems = header.querySelectorAll(".sub2-menu .menu-item");

  if (!megaMenu || sub1Menus.length === 0) return;

  let isFlyoutOpen = false;
  let parentIdentifier = "";
  let sub1Identifier = "";
  let sub2Identifier = "";
  let sub3Identifier = "";

  let submenuTimeout = null;
  const SUBMENU_DELAY = 300; // ms

  addEventListenerTo(menuItems, 1);
  addEventListenerTo(sub1MenuItems, 2);
  addEventListenerTo(sub2MenuItems, 3);

  function addEventListenerTo(menuItems, level) {
    for (const menuItem of menuItems) {
      const identifier = menuItem.dataset.identifier;

      menuItem.addEventListener(
        "mouseenter",
        () => {
          if (window.innerWidth < 1024) return;
          if (submenuTimeout) clearTimeout(submenuTimeout);
          submenuTimeout = setTimeout(() => {
            if (level === 1) sub1ItemOpen(menuItem, identifier);
            if (level === 2) sub2ItemOpen(menuItem, identifier);
            if (level === 3) sub3ItemOpen(menuItem, identifier);
          }, SUBMENU_DELAY);
        },
        { passive: true },
      );
      menuItem.addEventListener(
        "mouseleave",
        () => {
          if (submenuTimeout) {
            clearTimeout(submenuTimeout);
            submenuTimeout = null;
          }
        },
        { passive: true },
      );
    }
  }

  header.addEventListener(
    "mouseleave",
    () => {
      flyoutClose();
    },
    { passive: true }
  );

  const menuToggle = header.querySelector(".menu-toggle");
  menuToggle?.addEventListener("click", toggleMobileMenu, { passive: true });

  function sub1ItemOpen(item, identifier) {
    for (const menuItem of menuItems) {
      menuItem.classList.toggle("hover", menuItem === item);
    }

    isFlyoutOpen = true;
    parentIdentifier = identifier;
    sub1Identifier = identifier;
    sub2Identifier = "";
    sub3Identifier = "";
    toggleMegaMenu();
    toggleSubMenu(1);
  }

  function sub2ItemOpen(item, identifier) {
    for (const menuItem of sub1MenuItems) {
      menuItem.classList.toggle("hover", menuItem === item);
    }

    sub2Identifier = identifier;
    sub3Identifier = "";
    toggleMegaMenu();
    toggleSubMenu(2);
  }

  function sub3ItemOpen(item, identifier) {
    for (const menuItem of sub2MenuItems) {
      menuItem.classList.toggle("hover", menuItem === item);
    }

    sub3Identifier = identifier;
    toggleMegaMenu();
    toggleSubMenu(3);
  }

  function flyoutClose() {
    isFlyoutOpen = false;
    sub1Identifier = "";
    sub2Identifier = "";
    sub3Identifier = "";
    toggleMegaMenu(true);
  }

  function toggleMegaMenu(close = false) {
    if (close) {
      for (const item of allMenuItems) {
        item.classList.remove("hover");
      }

      if (megaMenu.classList.contains("show")) {
        toggleMenus(close);
      }
    } else {
      toggleMenus();
    }
  }

  function toggleMenus(close = false) {
    if (!close) {
      const identifiers = [sub1Identifier, sub2Identifier, sub3Identifier];

      for (const item of allItems) {
        const identifier = item.dataset.identifier;
        const parent = item.dataset.parentIdentifier;
        item.classList.toggle("show", identifiers.includes(identifier) && parentIdentifier === parent);
      }
    }

    toggleSubMenu(1);
    toggleSubMenu(2);
    toggleSubMenu(3);

    megaMenu.classList.toggle("show", isFlyoutOpen);
  }

  function toggleSubMenu(level = 1) {
    let subMenus = sub1Menus;
    let identifier = sub1Identifier;

    if (level === 2) {
      subMenus = sub2Menus;
      identifier = sub2Identifier;
    }

    if (level === 3) {
      subMenus = sub3Menus;
      identifier = sub3Identifier;
    }

    for (const subMenu of subMenus) {
      subMenu.classList.toggle("show", identifier !== "");
    }
  }

  function toggleMobileMenu() {
    isFlyoutOpen = !isFlyoutOpen;
    menuToggle.classList.toggle("show", isFlyoutOpen);
    header.classList.toggle("show", isFlyoutOpen);
    document.body.classList.toggle("overflow-hidden", isFlyoutOpen);

    header.querySelectorAll(".main-menu, .top-menu, #search").forEach((menu) => {
      menu.classList.toggle("show", isFlyoutOpen);
    });

    if (!isFlyoutOpen) {
      flyoutClose();
    }
  }

  for (const menuItem of [...menuItems, ...sub1MenuItems, ...sub2MenuItems]) {
    const unique = new Set();

    menuItem.querySelector(".menu-item-inner")?.addEventListener("click", () => {
      let isOpen;

      if (unique.has(menuItem)) {
        unique.delete(menuItem);
        isOpen = false;
      } else {
        unique.add(menuItem);
        isOpen = true;
      }

      const subMenu = menuItem.querySelector("[data-level]");
      if (!subMenu) return;
      toggleMobileSubmenu(menuItem, isOpen, subMenu);
    });
  }

  function toggleMobileSubmenu(menuItem, isOpen, subMenu) {
    menuItem.classList.toggle("show", isOpen);
    subMenu.classList.toggle("show", isOpen);
  }
};
